import React from "react";

const experienceContent = [
  {
    year: "April 2022 - Current",
    position: "Web Developer",
    compnayName: "CommonMedia GmbH",
   /* details: `  Lorem ipsum dolor sit amet, consectetur tempor incididunt ut labore
        adipisicing elit`,*/
  },
  {
    year: "August 2021 - December 2021",
    position: "Software Developer",
    compnayName: "agorum Software GmbH",
   /* details: `  Lorem ipsum dolor sit amet, consectetur tempor incididunt ut labore
        adipisicing elit`,*/
  },
  {
    year: "June 2020 - July 2021",
    position: "Android Developer",
    compnayName: "ShopiApps OÜ",
    /*details: `Lorem incididunt dolor sit amet, consectetur eiusmod dunt doldunt dol
        elit, tempor incididunt`,*/
  }
];

const Experience = () => {
  return (
    <ul>
      {experienceContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <img src="img/about/work.png" alt="icon" />
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.position}
            <span className="place open-sans-font">{val.compnayName}</span>
          </h5>
          <p className="open-sans-font">{val.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Experience;
